import React from 'react';
import {
  IconBan,
  IconAlertTriangle,
  IconSettings,
  IconStar,
  IconX,
  IconClock,
  IconCrown
} from '@tabler/icons-react';

const AdminModal = ({ isOpen, modalType, item, onClose, onConfirm, planDuration, setPlanDuration, selectedPlan, setSelectedPlan, tunnelLimit, setTunnelLimit, banReason, setBanReason, banDuration, setBanDuration }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-dark-900 rounded-2xl p-6 w-full max-w-md mx-4 border border-gray-200 dark:border-dark-800">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            {modalType === 'banUser' && <><IconBan className="w-5 h-5 text-red-500" /> Забанить пользователя</>}
            {modalType === 'blockTunnel' && <><IconAlertTriangle className="w-5 h-5 text-yellow-500" /> Заблокировать туннель</>}
            {modalType === 'limit' && <><IconSettings className="w-5 h-5 text-primary-500" /> Изменить лимит</>}
            {modalType === 'plan' && <><IconStar className="w-5 h-5 text-yellow-500" /> Изменить план</>}
          </h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 dark:text-dark-400 dark:hover:text-white">
            <IconX className="w-5 h-5" />
          </button>
        </div>

        {(modalType === 'banUser' || modalType === 'blockTunnel') && (
          <>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-dark-400 mb-2">
                Причина
              </label>
              <input
                type="text"
                value={banReason}
                onChange={(e) => setBanReason(e.target.value)}
                placeholder="Укажите причину..."
                className="w-full px-4 py-3 bg-gray-100 dark:bg-dark-800 border border-gray-300 dark:border-dark-700 rounded-xl text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-dark-600 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 dark:text-dark-400 mb-2">
                <IconClock className="w-4 h-4 inline mr-1" />
                Длительность
              </label>
              <select
                value={banDuration}
                onChange={(e) => setBanDuration(Number(e.target.value))}
                className="w-full px-4 py-3 bg-gray-100 dark:bg-dark-800 border border-gray-300 dark:border-dark-700 rounded-xl text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
              >
                <option value={0}>Навсегда</option>
                <option value={1}>1 час</option>
                <option value={6}>6 часов</option>
                <option value={24}>1 день</option>
                <option value={72}>3 дня</option>
                <option value={168}>1 неделя</option>
                <option value={720}>1 месяц</option>
              </select>
            </div>
            <div className="flex gap-3">
              <button
                onClick={onClose}
                className="flex-1 px-4 py-3 bg-gray-200 dark:bg-dark-800 text-gray-700 dark:text-white rounded-xl hover:bg-gray-300 dark:hover:bg-dark-700 transition-colors"
              >
                Отмена
              </button>
              <button
                onClick={onConfirm}
                className="flex-1 px-4 py-3 bg-red-500 text-white rounded-xl hover:bg-red-600 transition-colors"
              >
                {modalType === 'banUser' ? 'Забанить' : 'Заблокировать'}
              </button>
            </div>
          </>
        )}

        {modalType === 'limit' && (
          <>
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 dark:text-dark-400 mb-2">
                Лимит туннелей (0 = по умолчанию)
              </label>
              <input
                type="number"
                value={tunnelLimit}
                onChange={(e) => setTunnelLimit(Number(e.target.value))}
                min={0}
                max={100}
                className="w-full px-4 py-3 bg-gray-100 dark:bg-dark-800 border border-gray-300 dark:border-dark-700 rounded-xl text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
              <p className="text-xs text-gray-500 dark:text-dark-600 mt-2">
                Текущий план: {item?.plan === 'paid' ? 'PRO (20)' : 'Free (10)'}
              </p>
            </div>
            <div className="flex gap-3">
              <button
                onClick={onClose}
                className="flex-1 px-4 py-3 bg-gray-200 dark:bg-dark-800 text-gray-700 dark:text-white rounded-xl hover:bg-gray-300 dark:hover:bg-dark-700 transition-colors"
              >
                Отмена
              </button>
              <button
                onClick={onConfirm}
                className="flex-1 px-4 py-3 bg-primary-500 text-black rounded-xl hover:bg-primary-400 transition-colors"
              >
                Сохранить
              </button>
            </div>
          </>
        )}

        {modalType === 'plan' && (
          <>
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 dark:text-dark-400 mb-2">
                План подписки
              </label>
              <div className="flex gap-3">
                <button
                  onClick={() => setSelectedPlan('free')}
                  className={`flex-1 p-4 rounded-xl border-2 transition-all ${
                    selectedPlan === 'free'
                      ? 'border-gray-300 dark:border-dark-700 bg-gray-100 dark:bg-dark-800'
                      : 'border-gray-300 dark:border-dark-700 hover:border-gray-400 dark:hover:border-dark-600'
                  }`}
                >
                  <div className="text-lg font-bold text-gray-900 dark:text-white">Free</div>
                  <div className="text-sm text-gray-500 dark:text-dark-400">10 туннелей</div>
                  <div className="text-sm text-gray-500 dark:text-dark-400">5 доменов</div>
                </button>
                <button
                  onClick={() => setSelectedPlan('paid')}
                  className={`flex-1 p-4 rounded-xl border-2 transition-all ${
                    selectedPlan === 'paid'
                      ? 'border-yellow-500 bg-yellow-500/10'
                      : 'border-gray-300 dark:border-dark-700 hover:border-gray-400 dark:hover:border-dark-600'
                  }`}
                >
                  <div className="text-lg font-bold text-yellow-500 flex items-center gap-2">
                    <IconCrown className="w-5 h-5" /> PRO
                  </div>
                  <div className="text-sm text-gray-500 dark:text-dark-400">20 туннелей</div>
                  <div className="text-sm text-gray-500 dark:text-dark-400">20 доменов</div>
                </button>
              </div>
              
              {selectedPlan === 'paid' && (
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700 dark:text-dark-400 mb-2">
                    Срок подписки
                  </label>
                  <select
                    value={planDuration}
                    onChange={(e) => setPlanDuration(Number(e.target.value))}
                    className="w-full px-4 py-3 bg-gray-100 dark:bg-dark-800 border border-gray-300 dark:border-dark-700 rounded-xl text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
                  >
                    <option value={1}>1 месяц</option>
                    <option value={3}>3 месяца</option>
                    <option value={6}>6 месяцев</option>
                    <option value={12}>1 год</option>
                    <option value={0}>Бессрочно</option>
                  </select>
                </div>
              )}
              
              <p className="text-xs text-gray-500 dark:text-dark-600 mt-3">
                Текущий план: <span className="font-medium">{item?.plan === 'paid' ? 'PRO' : 'Free'}</span>
              </p>
            </div>
            <div className="flex gap-3">
              <button
                onClick={onClose}
                className="flex-1 px-4 py-3 bg-gray-200 dark:bg-dark-800 text-gray-700 dark:text-white rounded-xl hover:bg-gray-300 dark:hover:bg-dark-700 transition-colors"
              >
                Отмена
              </button>
              <button
                onClick={onConfirm}
                className="flex-1 px-4 py-3 bg-yellow-500 text-black rounded-xl hover:bg-yellow-400 transition-colors font-medium"
              >
                Сохранить
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminModal;